const url = process.env.VUE_APP_REMOTE_BACKEND_URL || 'http://localhost:3000'

async function getSessionState() {
  try {
    const remoteSessionStateResponse = await fetch(`${url}/sessionStatus`, {
      method: 'GET',
      mode: 'cors',
    })
    const remoteSessionStateObject = await remoteSessionStateResponse.json()
    return remoteSessionStateObject
  } catch(error) {
    console.error('Error while getting state', error)
    return 'error'
  }
}

async function getPayouts() {
  try {
    const payoutsResponse = await fetch(`${url}/payouts`, {
      method: 'GET',
      mode: 'cors',
    })
    const payoutsObject = (await payoutsResponse.json())
    return payoutsObject
  } catch(error) {
    console.error('error while getting payouts', error)
    throw error
  }
}

/**
 *
 * @param gRecaptchaResponse
 * @returns {Promise<any>} time in milliseconds to wait for faucet completion
 */
async function postFirstCaptcha({ gRecaptchaResponse, nanoAddress }) {
  try {
    const completedFirstCaptchaResponse = await fetch(`${url}/completedFirstCaptcha`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      mode: "cors",
      body: JSON.stringify({ gRecaptchaResponse, nanoAddress })
    })
    const completedFirstCaptchaObject = await completedFirstCaptchaResponse.json()
    return completedFirstCaptchaObject
  } catch(error) {
    console.error('Error while sending captcha', error)
    return null
  }
}

/**
 *
 * @returns {Promise<any>} returns block id if successful
 */
async function completeSession() {
  try {
    const completeSessionResponse = await fetch(`${url}/completeSession`, {
      method: 'GET',
      mode: "cors",
    })
    console.log(completeSessionResponse)
    if(!completeSessionResponse.ok) {
      throw 0
    }
    const completeSessionObject = await completeSessionResponse.json()
    console.log(completeSessionObject)
    if(completeSessionObject.state !== 'completed') { throw 0 }
    if(!completeSessionObject.block) { throw 0 }
    if(!completeSessionObject.payout) { throw 0 }
    return completeSessionObject
  } catch(error) {
    console.error('Error while completing session', error)
    throw 0
  }
}


export default {
  getSessionState,
  getPayouts,
  postFirstCaptcha,
  completeSession
}
